import { Component, OnInit} from '@angular/core';
import { CategoryService } from '@app/services/Category/category.service';
import { CountryService } from '@app/services/Country/country.service';
import { DistrictsService } from '@app/services/District/districts.service';
import { StatesService } from '@app/services/State/states.service';
import { SubCategoryService } from '@app/services/SubCategory/sub-category.service';

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.css']
})
export class BusinessComponent implements OnInit {
  categories: any;
  subCategories: any;
  businessAdsInfo:any;
  stateInfoId: any;
  districtInfoId: any;
  countryInfoId: any;

  constructor(
    private categoryService: CategoryService,
    private subCatSer: SubCategoryService,
    private countryService: CountryService,
    private stateService: StatesService,
    private distictService: DistrictsService
  ) { }
  
  //For child(business-list.component.ts)-to-parent-communication 
	toggleClass: boolean = false;
  eventHandler($event:any) {
    this.toggleClass = $event;
  }

  filterEvent(){
    this.toggleClass = !this.toggleClass;    
  }

  ngOnInit(){
    // this.categoryList();
    // this.subCategoryList();
    // this.countryList();
    // this.stateList();
    // this.distList();
  }

  categoryList() {
    this.categoryService.getAll().subscribe({
      next: (response: any) => {
        this.categories = response.data.map((item: any) => {
          return { name: item.CategoryName, id: item.CategoriesId };
        });
      }
    });
  }

  subCategoryList() {
    this.subCatSer.getAll().subscribe({
      next: (response: any) => {
        this.subCategories = response.data.map((item: any) => {
          return { name: item.SubCategoryName, id: item.SubCategoryInfoId }
        });
      }
    });
  }

  countryList() {
    this.countryService.getAll().subscribe({
      next: (response: any) => {
        this.countryInfoId = response.data.map((item: any) => {
          return { name: item.CountryName, id: item.CountryInfoId }
        });
      }
    });
  }

  stateList() {
    this.stateService.getAll().subscribe({
      next: (response: any) => {
        this.stateInfoId = response.data.map((item: any) => {
          return { name: item.StateName, id: item.StatesInfoId }
        });
      }
    });
  }

  distList() {
    this.distictService.getAll().subscribe({
      next: (response: any) => {
        this.districtInfoId = response.data.map((item: any) => {
          return { name: item.DistrictName, id: item.DistrictsInfoId }
        });
      }
    });
  }
}
